import { useEffect, useState } from 'react';
import { onNewVersion, watchNewVersion } from '@/lib/new-version';
import './NewVersionBanner.css';
import { useTranslation } from 'react-i18next';

/** Banda „versiune nouă", jos pe ecran, cu reîmprospătarea la alegerea omului. */
export function NewVersionBanner() {
  const { t } = useTranslation('common');
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const stop = watchNewVersion();
    const off = onNewVersion(() => setShown(true));
    return () => {
      stop();
      off();
    };
  }, []);
  if (!shown) return null;
  return (
    <div className="nvb" role="status">
      <span>{t('aAparutOVersiune')}</span>
      <button type="button" onClick={() => globalThis.location.reload()}>
        {t('reimprospateazaPagina')}
      </button>
      <button type="button" className="nvb__later" onClick={() => setShown(false)}>
        {t('maiTarziu')}
      </button>
    </div>
  );
}
